import { gfmStrikethroughFromMarkdown } from 'mdast-util-gfm-strikethrough';
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough';

export function strikethroughPlugin(settings: any) {
  // @ts-expect-error: TS is wrong about `this`.
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const self: any = this;
  const data = self.data();

  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);

  micromarkExtensions.push(gfmStrikethrough(settings));
  fromMarkdownExtensions.push(gfmStrikethroughFromMarkdown());
}
